(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[389],{

/***/ 91903:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/favorites",
      function () {
        return __webpack_require__(8001);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useIsMounted() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isMounted = ref[0], setIsMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setIsMounted(true);
    }, []);
    return isMounted;
}
/* harmony default export */ __webpack_exports__["Z"] = (useIsMounted);


/***/ }),

/***/ 23377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ ClientOnly; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var ClientOnly = function(_param) {
    var children = _param.children, delegated = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hasMounted = ref[0], setHasMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setHasMounted(true);
    }, []);
    if (!hasMounted) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, delegated), {
        children: children
    }));
};


/***/ }),

/***/ 8001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ favorites; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/core/components/common/AppHead.tsx
var AppHead = __webpack_require__(46055);
// EXTERNAL MODULE: ./src/core/layouts/AppLayout.tsx + 27 modules
var AppLayout = __webpack_require__(74797);
// EXTERNAL MODULE: ./src/core/hooks/use-is-mounted.ts
var use_is_mounted = __webpack_require__(10773);
// EXTERNAL MODULE: ./src/lib/ClientOnly.tsx
var ClientOnly = __webpack_require__(23377);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(72445);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(71232);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(82623);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Loader/Loader.js + 3 modules
var Loader = __webpack_require__(20966);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/SimpleGrid/SimpleGrid.js + 1 modules
var SimpleGrid = __webpack_require__(69469);
// EXTERNAL MODULE: ./src/features/common/cards/PropertyItem/PropertyItemCard.tsx + 3 modules
var PropertyItemCard = __webpack_require__(66127);
// EXTERNAL MODULE: ./src/features/common/hooks/use-user-data.ts
var use_user_data = __webpack_require__(85992);
// EXTERNAL MODULE: ./src/core/utils/network-utils.ts
var network_utils = __webpack_require__(41448);
// EXTERNAL MODULE: ./src/core/utils/dxb-utils.ts
var dxb_utils = __webpack_require__(10646);
// EXTERNAL MODULE: ./src/generated/graphql.tsx
var graphql = __webpack_require__(89402);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./src/features/favorites/containers/FavoritesPageLanding.styles.ts

/* harmony default export */ var FavoritesPageLanding_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        progress: {
            textAlign: "center"
        },
        favoritesLanding: {
            margin: "0 auto",
            maxWidth: theme.other.maxWidth,
            paddingLeft: 20,
            paddingRight: 20
        },
        h1: {
            textAlign: "center",
            letterSpacing: 0.6,
            width: "100%",
            color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.gray[7]
        },
        h2: {
            textAlign: "center",
            letterSpacing: 0.6,
            width: "100%",
            color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.gray[7]
        },
        titleGroup: {
            gap: 0
        },
        // no favourite message
        paper: {
            margin: "0 auto",
            textAlign: "justify",
            fontSize: 12,
            maxWidth: 500,
            padding: 20,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.gray[8] : theme.colors.gray[3],
            boxShadow: theme.shadows.sm,
            color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.gray[7]
        },
        submitButton: {
            fontWeight: 500,
            textTransform: "uppercase",
            letterSpacing: 1,
            width: "100%"
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/favorites/containers/FavoritesPageLanding.tsx










var FavoritesPageLanding = function() {
    var ref;
    var classes = FavoritesPageLanding_styles().classes;
    var isMounted = (0,use_is_mounted/* default */.Z)();
    var getUserEmail = (0,use_user_data/* default */.Z)().getUserEmail;
    var ref1 = (0,react.useState)([]), localData = ref1[0], setLocalData = ref1[1];
    var ref2 = (0,graphql/* useGetUserFavPropertiesQuery */.Vj)({
        variables: {
            email: getUserEmail()
        },
        fetchPolicy: "network-only"
    }), data = ref2.data, loading = ref2.loading, error = ref2.error;
    (0,react.useEffect)(function() {
        if (data === null || data === void 0 ? void 0 : data.getUserFavProperties) {
            setLocalData(data.getUserFavProperties);
        }
    }, [
        data
    ]);
    var propertyItems = localData.map(function(property) {
        var ref, ref1;
        var thumbUrl = (ref1 = property === null || property === void 0 ? void 0 : (ref = property.images) === null || ref === void 0 ? void 0 : ref.filter(function(img) {
            return img.type === "thumb" && img;
        })[0]) === null || ref1 === void 0 ? void 0 : ref1.src;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PropertyItemCard/* PropertyItemCard */.o, {
                propertyId: property.id,
                name: property.name,
                thumb: thumbUrl && "".concat(network_utils/* S3_PROPERTY_BUCKET_URL */.oe, "/").concat(thumbUrl),
                address: (0,dxb_utils/* getAddressText */.ol)(property.location),
                amount: property.priceDetails.pricePerNight,
                currency: "AED",
                details: property.details,
                isFeatured: property.settings.is_featured,
                isPropertyPage: true,
                settings: property.settings,
                isFavVisible: true,
                isFav: true
            })
        }, property.id);
    });
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: classes.favoritesLanding,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    className: classes.titleGroup,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            className: classes.h1,
                            order: 1,
                            children: "Your Favourite Properties"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            className: classes.h2,
                            order: 2,
                            children: "Choose from the properties you like and book your experience now"
                        })
                    ]
                }),
                error || (data === null || data === void 0 ? void 0 : (ref = data.getUserFavProperties) === null || ref === void 0 ? void 0 : ref.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* Paper */.X, {
                    mt: 30,
                    className: classes.paper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                            className: classes.h1,
                            order: 1,
                            children: "No favorite properties found"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            pt: 20,
                            pb: 20,
                            children: "You have not added any properties to this list. Click the heart icon on the property you like to add it to your favorites."
                        })
                    ]
                }),
                loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* Paper */.X, {
                    mt: 30,
                    className: classes.progress,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                        color: "#f39c12",
                        variant: "dots",
                        size: "sm"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                    mt: 20,
                    mb: 20,
                    cols: 3,
                    breakpoints: [
                        {
                            maxWidth: "xl",
                            cols: 3,
                            spacing: "sm"
                        },
                        {
                            maxWidth: "md",
                            cols: 2,
                            spacing: "sm"
                        },
                        {
                            maxWidth: "sm",
                            cols: 1,
                            spacing: 0
                        }, 
                    ],
                    children: propertyItems
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/favorites.tsx






var FavoritesPage = function() {
    var isMounted = (0,use_is_mounted/* default */.Z)();
    return isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientOnly/* ClientOnly */.q, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoritesPageLanding, {})
    });
};
// @ts-expect-error
FavoritesPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHead/* default */.Z, {
                title: "Your Favorite Properties",
                description: "Properties you are interested in and have added to your list of favourites in order to book or have a look at later."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout/* default */.Z, {
                requireAuth: true,
                noHeader: false,
                children: page
            })
        ]
    });
};
/* harmony default export */ var favorites = (FavoritesPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [584,662,930,553,207,127,774,888,377], function() { return __webpack_exec__(91903); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);